export const MENU_DRAWER_WIDTH_LARGE = 240;
export const MENU_DRAWER_WIDTH_SMALL = 80;
